import {SilverFocusable} from './lib/index.js';

window.tvcnpt = window.tvcnpt || {};
window.tvcnpt.SilverFocusable = SilverFocusable;
module.exports = SilverFocusable;



// WEBPACK FOOTER //
// ./~/silver-focusable/index.js